/** Formatage francophone, sans dépendance externe. */

export function pourcentage(part: number, tout: number): string {
  if (tout <= 0) return '—';
  return `${Math.round((part / tout) * 100)} %`;
}

export function dateLongue(valeur: number | string | Date): string {
  const date = valeur instanceof Date ? valeur : new Date(valeur);
  if (Number.isNaN(date.getTime())) return '—';
  return new Intl.DateTimeFormat('fr-FR', { dateStyle: 'long' }).format(date);
}

export function dateHeure(valeur: number): string {
  const date = new Date(valeur);
  if (Number.isNaN(date.getTime())) return '—';
  return new Intl.DateTimeFormat('fr-FR', { dateStyle: 'short', timeStyle: 'short' }).format(date);
}

export function pluriel(nombre: number, singulier: string, plurielMot: string): string {
  return `${nombre} ${nombre > 1 ? plurielMot : singulier}`;
}

/** Nettoie un nom de fichier pour un export. */
export function nomFichier(base: string, extension: string): string {
  const sur = base
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[^a-zA-Z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')
    .toLowerCase();
  return `${sur || 'election'}.${extension}`;
}

export function telecharger(nom: string, contenu: string, type = 'application/json'): void {
  const blob = new Blob([contenu], { type: `${type};charset=utf-8` });
  const url = URL.createObjectURL(blob);
  const lien = document.createElement('a');
  lien.href = url;
  lien.download = nom;
  lien.click();
  URL.revokeObjectURL(url);
}
